// @flow
import Loadable from '@src/components/Loadable';

const NotFoundLoader = Loadable({
  loader: () => import('./500'),
});

export default NotFoundLoader;
